export class Countdown{
	init() {
		var countDownDate = new Date("Jun 25, 2019 15:30:00").getTime();

	// Update the count down every 1 second
	if(document.getElementById("countdown") !== null){
		var x = setInterval(function() {

		// Get today's date and time
			var now = new Date().getTime();

			// Find the distance between now and the count down date
			var distance = countDownDate - now;

			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);

			// Display the result in the element with id="demo"
				document.getElementById("countdown").innerHTML = "<span class='h2 d-block '>"+days + "d " + hours + "h "
				+ minutes + "m " + seconds + "s </span>";

			// If the count down is finished, write some text
			if (distance < 0) {
				clearInterval(x);
					document.querySelectorAll(".countdown-container")[0].style.display = "none";
					document.querySelectorAll(".countdown-container")[0].remove();
				}
			}, 1000);
		}
	}
}